export const EMDR_INBOX_PAGE_TABS = {
  INBOX_TAB: "Inbox",
  HISTORY_TAB: "History",
};

export const ATTACHMENT_LEVEL_NAME = {
  EXTERNAL_AUDIT: "EA",
  EXTERNAL_AUDIT_CASE: "EAC",
};
export const AUDIT_LIST_TYPE={
  EMDR_TYPE:'EMDR',
  CASE_LIST:'LIST',
  AUDIT_WITH_CASES:'CASES'
}

export const EMDR_ATTACH_POPUP_MODE = {
  ATTACH_DOCUMENT: "ATTACH_DOCUMENT",
  ADD_CASES: "ADD_CASES",
};
